import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { API_ENDPOINT } from '../../utils/Constants';

import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import dayjs from 'dayjs';
import Plotly from 'plotly.js';
import createPlotlyComponent from 'react-plotly.js/factory';
const Plot = createPlotlyComponent(Plotly);

const Graph1 = () => {
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);

  const [traces, setTraces] = useState([]);
  const [rows, setRows] = useState([]);
  const [rowsTitle, setRowsTitle] = useState([]);
  
  const [operator, setOperator] = useState([]);
  const [taskset, setTaskset] = useState([]);
  const [selectedTaskset, setSelectedTaskset] = useState('');
  const [selectedOperator, setSelectedOperator] = useState('');

  const layout: any = {
    title: 'ジョブ平均時間',
    barmode: 'stack',
    yaxis: {
      autorange: true,
      title: '時間 (秒)',
      titlefont: {
        size: 20,
      },
    },
  };

  const handleChange1 = (event: SelectChangeEvent) => {
    setSelectedTaskset(event.target.value as string);
  };

  const handleChange2 = (event: SelectChangeEvent) => {
    setSelectedOperator(event.target.value as string);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      axios
        .post(API_ENDPOINT + 'graph1', {
          startDate,
          endDate,
          selectedOperator,
          selectedTaskset,
        })
        .then((res) => {
          const data = res.data.data;
          // graph data
          const t = [];
          for (let i= 0; i < data.length; i++){
            const trace = {
              x: data[i].task,
              y: data[i].avg_duration,
              name: data[i].job,
              hovertemplate: '<b>%{y}秒</b>',
              type: 'bar',
            };
            t.push(trace);
          }
          setTraces(t);

          // table data
          const rw = [];
          const taskNameList = [];
          for (let i= 0; i < data.length; i++){
            if (taskNameList.indexOf(data[i].task[0]) === -1){
              taskNameList.push(data[i].task[0]);
            }
          }
          for (let k= 0; k < taskNameList.length; k++){
            rw.push({'taskName': taskNameList[k], 'data': []});
            for (let i= 0; i < data.length; i++){
              if (rw[k].taskName === data[i].task[0]){
                rw[k].data.push(data[i]);
              }
            }
          }
          setRows(rw);
          setRowsTitle([{'tasksetName': selectedTaskset.split(':')[1], 'operatorName': selectedOperator.split(':')[1]}]);
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  // -----------------
  const defaultTraces = useCallback((defaultOperator, defaulTaskset) => {
    axios.post(API_ENDPOINT + 'graph1', {
      'startDate': dayjs().subtract(1, 'd'),
      'endDate': dayjs(),
      'selectedOperator': defaultOperator,
      'selectedTaskset': defaulTaskset
    })
      .then((res) => {
        const data = res.data.data;
        // graph data
        const t = [];
        for (let i= 0; i < data.length; i++){
          const trace = {
            x: data[i].task,
            y: data[i].avg_duration,
            name: data[i].job,
            hovertemplate: '<b>%{y}秒</b>',
            type: 'bar',
          };
          t.push(trace);
        }
        setTraces(t);

        // table data
        const rw = [];
        const taskNameList = [];
        for (let i= 0; i < data.length; i++){
          if (taskNameList.indexOf(data[i].task[0]) === -1){
            taskNameList.push(data[i].task[0]);
          }
        }
        for (let k= 0; k < taskNameList.length; k++){
          rw.push({'taskName': taskNameList[k], 'data': []});
          for (let i= 0; i < data.length; i++){
            if (rw[k].taskName === data[i].task[0]){
              rw[k].data.push(data[i]);
            }
          }
        }
        setRows(rw);
        setRowsTitle([{'tasksetName': defaulTaskset.split(':')[1], 'operatorName': defaultOperator.split(':')[1]}]);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const getStatus = useCallback(() => {
    axios
      .get(API_ENDPOINT + 'graph1')
      .then((res) => {
        setTaskset(res.data.data[0]);
        setOperator(res.data.data[1]);
        defaultTraces(res.data.data[1][0][0] + ':' + res.data.data[1][0][1], res.data.data[0][0][0] + ':' + res.data.data[0][0][1]);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [defaultTraces]);

  useEffect(() => {
    getStatus();
  }, [getStatus]);

  return (
    <Stack spacing={2}>
      <Stack direction='row' spacing={2}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <FormControl fullWidth>
            <DatePicker label='Start Date' value={startDate} onChange={(newValue) => setStartDate(newValue)} renderInput={(params) => <TextField {...params} />} />
          </FormControl>
          <FormControl fullWidth>
            <DatePicker label='End Date' value={endDate} onChange={(newValue) => setEndDate(newValue)} renderInput={(params) => <TextField {...params} />} />
          </FormControl>
        </LocalizationProvider>
        <FormControl fullWidth>
          <InputLabel>実行タスクセット</InputLabel>
          <Select label='task set' value={selectedTaskset} onChange={handleChange1}>
            {taskset.map((item) => (
              <MenuItem value={item[0] + ':' + item[1]} key={item[0] + ':' + item[1]}>{item[1]}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth>
          <InputLabel>オペレーター選択</InputLabel>
          <Select label='Operator' value={selectedOperator} onChange={handleChange2}>
            {operator.map((item) => (
              <MenuItem value={item[0] + ':' + item[1]} key={item[0] + ':' + item[1]}>{item[1]}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button variant='contained' onClick={handleSubmit}>検索</Button>
      </Stack>

      <Plot data={traces} layout={layout} config={{'displayModeBar': false}} />


      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label='simple table'>
          <TableHead>
            <TableRow>
              <TableCell>オペレーター</TableCell>
              <TableCell>タスクセット</TableCell>
              <TableCell>タスク名</TableCell>
              <TableCell>ジョブ名</TableCell>
              <TableCell>ジョブ実行回数</TableCell>
              <TableCell>継続時間(秒)</TableCell>
              <TableCell>開始時刻</TableCell>
              <TableCell>終了時刻</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rowsTitle.map((item, index0) => {
              let tasksetrowSpanNum = 1 + 2 * rows.length;
              for (let i= 0; i < rows.length; i++){
                for (let k= 0; k < rows[i].data.length; k++){
                  tasksetrowSpanNum += rows[i].data[k].duration.length + 1;
                }
              }
              return (
                <>
                  <TableRow key={item.operatorName+index0}>
                    <TableCell rowSpan={tasksetrowSpanNum}>{item.operatorName}</TableCell>
                  </TableRow>
                  <TableRow key={item.tasksetName+index0}>
                    <TableCell rowSpan={tasksetrowSpanNum}>{item.tasksetName}</TableCell>
                  </TableRow>
                  {rows.map((task, index1) => {
                    let taskrowSpanNum = 1;
                    for (let i= 0; i < task.data.length; i++){
                      taskrowSpanNum += task.data[i].duration.length + 1;
                    }
                    return (
                      <>
                        <TableRow key={task.taskName+index1}>
                          <TableCell rowSpan={taskrowSpanNum}>{task.taskName}</TableCell>
                        </TableRow>

                        {task.data.map((job, index2) => {
                          const jobrowSpanNum = job.duration.length + 1;
                          return (
                            <>
                              <TableRow key={job.job+index2}>
                                <TableCell rowSpan={jobrowSpanNum}>{job.job}</TableCell>
                                <TableCell rowSpan={jobrowSpanNum}>{job.duration.length}回</TableCell>
                              </TableRow>
                              {job.duration.map((duration, i) => (
                                <TableRow key={job.start_date[i]+index2}>
                                  <TableCell>{duration}秒</TableCell>
                                  <TableCell>{job.start_date[i].substring(0,job.start_date[i].length-3)}</TableCell>
                                  <TableCell>{job.end_date[i].substring(0,job.start_date[i].length-3)}</TableCell>
                                </TableRow>
                              ))}
                            </>
                          );
                        })} 
                      </>
                    );
                  })}  
                </>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  );
};

export default Graph1;
